// Reine, frameworkfreie Logik fuer multiDragdrop-Fragen.
// placements hat die Form { [targetId]: pieceId } (welches Teil liegt auf welchem Ziel).
// Korrektheitsregel: ein Teil gehoert auf das Ziel mit gleicher id.

export function pieceLabel(piece, index) {
  if (!piece) return `Teil ${index + 1}`;
  if (piece.label) return piece.label;
  if (piece.text) return piece.text;
  if (piece.image) return `Bild ${index + 1}`;
  return `Teil ${index + 1}`;
}

export function targetLabel(target, index) {
  if (!target) return `Ziel ${index + 1}`;
  if (target.label) return target.label;
  if (target.text) return target.text;
  if (target.image) return `Bild ${index + 1}`;
  return `Ziel ${index + 1}`;
}

export function allPlaced(placements, pieces) {
  return Object.keys(placements || {}).length === (pieces || []).length;
}

export function allCorrect(placements) {
  const entries = Object.entries(placements || {});
  if (entries.length === 0) return false;
  return entries.every(([targetId, pieceId]) => String(pieceId) === String(targetId));
}

export function buildPlacementDetails(placements, pieces, targets) {
  // Umkehrung: pieceId -> targetId
  const byPiece = {};
  Object.entries(placements || {}).forEach(([targetId, pieceId]) => {
    byPiece[String(pieceId)] = String(targetId);
  });
  return (pieces || []).map((piece, i) => {
    const chosenTargetId = byPiece[String(piece.id)];
    const chosenTarget = (targets || []).find((t) => String(t.id) === String(chosenTargetId));
    const correctTarget = (targets || []).find((t) => String(t.id) === String(piece.id));
    const correct = chosenTargetId != null && String(chosenTargetId) === String(piece.id);
    return {
      pieceLabel: pieceLabel(piece, i),
      chosenTargetLabel: chosenTarget ? targetLabel(chosenTarget, (targets || []).indexOf(chosenTarget)) : '—',
      correctTargetLabel: correctTarget ? targetLabel(correctTarget, (targets || []).indexOf(correctTarget)) : '—',
      correct,
    };
  });
}
